module.exports = __webpack_public_path__ + "img/icon_e3.06e8e4d9.png";